module.exports = __webpack_public_path__ + "uz.svg?519585c39d3ee3a0c8b8cd647c5c255d";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/uz.svg
// module id = 1410
// module chunks = 27